import { render } from "./ComissaoExport.vue?vue&type=template&id=31ee22d4"
import script from "./ComissaoExport.vue?vue&type=script&lang=js"
export * from "./ComissaoExport.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__